module.exports = __webpack_public_path__ + "img/lanl.e225e6ec.png";